import { gql } from "@apollo/client";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import {
  Alert,
  Button,
  Card,
  Container,
  Skeleton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { useState } from "react";

import Help from "~/components/common/Help";
import { useOrganizationalUnitsQuery } from "~/graphql/__generated__/graphql";

import OrganizationalUnitRow, { OrganizationalUnitDialog } from "./OrganizationalUnitRow";

const TabOrganizationalUnits = () => {
  const [createDialogOpen, setCreateDialogOpen] = useState(false);
  const { data, loading, error } = useOrganizationalUnitsQuery();

  return (
    <Container maxWidth={false} sx={{ mt: 4, mb: 4 }}>
      {error ? (
        <Alert severity="error">Unable to load organizational units.</Alert>
      ) : (
        <Card sx={{ height: "100%" }}>
          <TableContainer>
            <Table sx={{ tableLayout: "fixed" }}>
              <TableHead>
                <TableRow>
                  <TableCell sx={{ width: "70%" }}>
                    Organizational Unit
                    <Help text="An operating group used to segment users, episodes, and scheduling (for example, a region or market)." />
                  </TableCell>
                  <TableCell sx={{ width: "15%" }}>Status</TableCell>
                  <TableCell sx={{ width: "15%" }}>Active</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {loading ? (
                  <>
                    <RowSkeleton />
                    <RowSkeleton />
                    <RowSkeleton />
                  </>
                ) : data?.organizationalUnit.length ? (
                  data.organizationalUnit.map((organizationalUnit) => (
                    <OrganizationalUnitRow
                      key={organizationalUnit.id}
                      organizationalUnit={organizationalUnit}
                    />
                  ))
                ) : (
                  <TableRow>
                    <TableCell colSpan={3} sx={{ textAlign: "center" }}>
                      No organizational units found
                    </TableCell>
                  </TableRow>
                )}
                <TableRow>
                  <TableCell colSpan={3}>
                    <Button
                      onClick={() => setCreateDialogOpen(true)}
                      size="small"
                      startIcon={<AddCircleOutlineIcon fontSize="small" />}
                    >
                      Add New Organizational Unit
                    </Button>
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
        </Card>
      )}

      {createDialogOpen && (
        <OrganizationalUnitDialog onClose={() => setCreateDialogOpen(false)} />
      )}
    </Container>
  );
};

export default TabOrganizationalUnits;

const RowSkeleton = () => (
  <TableRow>
    <TableCell><Skeleton width="100%" /></TableCell>
    <TableCell><Skeleton width="100%" /></TableCell>
    <TableCell><Skeleton width="100%" /></TableCell>
  </TableRow>
);

gql`
  query OrganizationalUnits @permission(requires: manageOrgConfig) {
    organizationalUnit(orderBy: { name: { direction: asc, priority: 1 } }) {
      id
      name
      active
    }
  }
`;
